import Vue from "vue";
import VueRouter from "vue-router";
// @ts-ignore
import goodsAll from "../views/goodsAll";

Vue.use(VueRouter);
/**
 * 解决重复点击相同路由控制台报错
 */
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: "/",
    name: "",
    redirect:'/workTable/myGoods'
  },
  {
    path: "/goodsAll",
    name: "goodsAll",
    component: goodsAll,
    meta: { title: '选品池' }
  },
  {
    path: "/workTable",
    name: "workTable",
    // @ts-ignore
    component: () => import("@/views/workTable"),
    meta: { title: '我的工作台' },
    redirect:'/workTable/myGoods',
    children: [
      {
        path: "/workTable/myGoods",
        name: "myGoods",
        icon: 'icon-wodeshangpinku',
        // @ts-ignore
        component: () => import("@/views/workTable/myGoods"),
        meta: { title: '我的商品库', permission: 'one' },
      },
      {
        path: "/workTable/myPeople",
        name: "myPeople",
        icon: 'icon-wodedaren',
        // @ts-ignore
        component: () => import("@/views/workTable/myPeople"),
        meta: { title: '我的达人' },
      },
      {
        path: "/workTable/sampleCooperation",
        name: "sampleCooperation",
        icon: 'icon-jiyanghezuo',
        // @ts-ignore
        component: () => import('@/views/workTable/sampleCooperation'),
        meta:{ title: '寄样合作' },
        children:[
          {
            path: "/workTable/sampleCooperation/TalentSample",
            name: "TalentSample",
            // @ts-ignore
            component: () => import("@/views/workTable/sampleCooperation/TalentSample"),
            meta: { title: '达人寄样' },
          },
          {
            path: "/workTable/sampleCooperation/HeadSample",
            name: "HeadSample",
            // @ts-ignore
            component: () => import("@/views/workTable/sampleCooperation/HeadSample"),
            meta: { title: '团长寄样' },
          },
        ]
      },
      {
        path: "/workTable/groupManagement",
        name: "报团管理",
        icon: 'icon-baotuanguanli',
        // @ts-ignore
        component: () => import('@/views/workTable/groupManagement'),
        meta:{ title: '报团管理', permission: 'one',showIt: true },
        children:[
          {
            path: "/workTable/groupManagement/myGroup",
            name: "myGroup",
            // @ts-ignore
            component: () => import("@/views/workTable/groupManagement/myGroup"),
            meta: { title: '我报的团', permission: 'one' },
          },
          {
            path: "/workTable/groupManagement/GroupBy",
            name: "GroupBy",
            // @ts-ignore
            component: () => import("@/views/workTable/groupManagement/groupBy"),
            meta: { title: '报我的团' },
          },
        ]
      },
      {
        path: "/workTable/extentionResult",
        name: "推广效果",
        icon: 'icon-tuiguangxiaoguo',
        // @ts-ignore
        component: () => import('@/views/workTable/extentionResult'),
        meta:{ title: '推广效果' },
        children:[
          {
            path: "/workTable/extentionResult/orderList",
            name: "orderList",
            // @ts-ignore
            component: () => import("@/views/workTable/extentionResult/orderList"),
            meta: { title: '订单明细' },
          },
          {
            path: "/workTable/extentionResult/orderRank",
            name: "orderRank",
            // @ts-ignore
            component: () => import("@/views/workTable/extentionResult/orderRank"),
            meta: { title: '出单排行' },
          },
          {
            path: "/workTable/extentionResult/performance",
            name: "performance",
            // @ts-ignore
            component: () => import("@/views/workTable/extentionResult/performance"),
            meta: { title: '员工业绩' },
          }
        ]
      }
    ]
  },
  {
    path: "/management",
    name: "management",
    // @ts-ignore
    component: () => import("../views/management/index.vue"),
    redirect:'/management/managementData',
    meta: { title: '管理团队' },
    children: [
      {
        path: "/management/managementData",
        name: "managementData",
        icon: 'icon-tuanduiziliao',
        // @ts-ignore
        component: () => import("../views/management/managementData"),
        meta: { title: '员工资料' }
      },
      {
        path: "/management/employeeAccount",
        name: "employeeAccount",
        icon: 'icon-yuangongzhanghao',
        // @ts-ignore
        component: () => import("../views/management/employeeAccount"),
        meta: { title: '员工账号' }
      },
      {
        path: "/management/authorization",
        name: "authorization",
        icon: 'icon-shouquanguanli',
        // @ts-ignore
        component: () => import("../views/management/authorization"),
        meta: { title: '授权管理' }
      }
    ]
  }
];

const router = new VueRouter({
  routes,
});

export default router;
